import { Settings, Image, Hash, ReceiptText, Smartphone, Boxes, Mic } from "lucide-react";
import { GUIDE } from "@/lib/setupGuide";
import { useLang } from "@/lib/i18n";

const ICONS = [Settings, Image, Hash, ReceiptText, Smartphone, Boxes, Mic];

export default function SetupGuide() {
  const { lang } = useLang();
  const G = GUIDE[lang] || GUIDE.en;
  return (
    <div data-testid="setup-guide" className="bg-[#006D5B]/5 border border-[#006D5B]/15 rounded-2xl p-4 text-left mb-6">
      <p className="font-heading font-bold text-sm text-[#006D5B]">{G.title}</p>
      <p className="text-[11px] text-gray-500 mb-3">{G.sub}</p>
      <ol className="space-y-2.5">
        {G.steps.map((s, i) => {
          const Icon = ICONS[i] || Settings;
          return (
            <li key={i} data-testid="setup-guide-step" className="flex items-start gap-2.5">
              <span className="shrink-0 w-6 h-6 rounded-full bg-[#006D5B] text-white text-[10px] font-bold flex items-center justify-center mt-0.5">{i + 1}</span>
              <span className="text-[12px] text-gray-700 leading-snug flex-1">{s}</span>
              <Icon size={14} className="shrink-0 text-[#006D5B]/60 mt-1" />
            </li>
          );
        })}
      </ol>
    </div>
  );
}
